import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Grid2,
    Stack,
    TextField,
    Autocomplete,
    Chip
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableComponent from "components/grid";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useParams } from "react-router-dom";
import { useGetAllWorkflowQuery, useGetEntityCategoryListQuery } from "store/slices/apis/workflowSlice";
import { FaPlus } from "react-icons/fa6";
import AddWorkFlow from "./AddWorkFlow";
import moment from "moment";
import EditWorkFlow from "./EditWorkFlow";
import { usePermission } from "hooks/usePermission";
import { WORKFLOW_EDIT, WORKFLOW_CREATE } from "config";
import {ReactComponent as AddNewIcon} from "assets/PwC_Funct_Icons_Plus_Outline_Black_RGB.svg"


const AllWorkFlowList = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const editAccess = usePermission(WORKFLOW_EDIT);
    const addAccess = usePermission(WORKFLOW_CREATE);

    const [isWorkFlow, setIsWorkFlow] = useState(false);
    const [isEditWorkFLow, setIsEditWorkFLow] = useState(false);
    const [rowData, setRowData] = useState(null);
    const [categoryList, setCategoryList] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [filters, setFilters] = useState({
        category: "",
    });
    const [category, setCategory] = useState("");
    const { projectId } = useParams();
    const workflowList = useGetAllWorkflowQuery({ projectId, pageNumber, pageSize: 10, entityName: filters?.category })
    const categoryRes = useGetEntityCategoryListQuery();

    const handleAddWorkFlow = () => {
        setIsWorkFlow(!isWorkFlow);
    }

    useEffect(() => {
        if (categoryRes?.isSuccess) {
            setCategoryList(categoryRes?.data?.data?.[0]?.items)
        }
    }, [categoryRes])

    const openNotification = async (msg, type = 'error') => {
        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), 3000);
    };

    const handleEditWorkFlow = (row) => {
        setIsEditWorkFLow((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const columns = [
        {
            name: "Workflow Name",
            field: "workflowName",
        },
        {
            name: "Entity Type",
            field: "entityName",
        },
        // {
        //     name: "TAT",
        //     field: "tat",
        // },
        {
            name: "Status",
            field: "entityName",
            renderer(params) {
                return (
                    <Stack direction="row" spacing={1}>
                        <Chip size="small" sx={{
                            fontSize: '12px',
                            '& .MuiChip-label': {
                                paddingLeft: '8px',
                                paddingRight: '8px',
                                fontWeight: 600
                            }
                        }} label={`${params?.active ? `Active` : `Inactive`}`} color={`${params?.active ? `success` : `error`}`} />
                    </Stack>
                );
            }
        },
        {
            name: "Created at",
            field: "entityName",
            renderer(params) {
                return (
                    <Stack direction="row" spacing={1}>
                        {moment(params?.createdDate).format("DD/MM/YYYY")
                        }
                    </Stack>
                );
            }
        },
        {
            name: 'Action',
            field: 'action',
            option: {}
        },
    ]

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: "20px" }}>
                <Grid2 size={12}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: { xs: 'start', sm: 'center' },
                            justifyContent: "space-between",
                            flexDirection: { xs: 'column', sm: 'row' }
                        }}
                    >
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            sx={{
                                // flexGrow: 2,
                                alignItems: { xs: "stretch", sm: "center" }, // Full width on mobile
                                width: { xs: '100%', sm: 'auto' }, // Stack takes full width
                                "& .MuiStack-root": {
                                    paddingTop: "15px",
                                },
                            }}
                        >
                            <Autocomplete
                                options={categoryList}
                                getOptionLabel={(option) => option?.value}
                                onChange={(_, newValue) =>
                                    setCategory(newValue ? newValue?.value : '')
                                }
                                value={categoryList?.find((option) => option.value === category) || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Entity type"
                                        name="currentStatus"
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                padding: '8px !important', // Remove wrapper padding
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{
                                    sx: { fontSize: '13px' },
                                }}
                                sx={{
                                    width: { xs: '100%', sm: '300px' },
                                    marginTop: '15px !important'
                                }}
                            />
                            <Stack spacing={2} direction="row" sx={{ mt: '0px !important' }}>
                                <Button
                                    fullWidth
                                    loading={workflowList?.isLoading}
                                    onClick={() => {
                                        setFilters({ category: category });
                                        setPageNumber(1);
                                    }}
                                    size="large"
                                    variant="outlined"
                                    sx={{
                                        color: `${theme?.customSettings?.themeColor}`,
                                        border: `1px solid ${theme?.customSettings?.themeColor}`,
                                        background: "none",
                                        textTransform: "inherit",
                                        padding: "6px 15px",
                                        // marginTop: "12px !important",
                                    }}
                                >
                                    Search
                                </Button>
                                <Button
                                    fullWidth
                                    loading={workflowList?.isLoading}
                                    onClick={() => {
                                        setCategory("");
                                        const clearedValues = Object.fromEntries(
                                            Object.keys(filters).map((key) => [key, ""])
                                        );
                                        setFilters(clearedValues);
                                    }}
                                    size="large"
                                    variant="outlined"
                                    sx={{
                                        color: `${theme?.customSettings?.themeColor}`,
                                        border: `1px solid ${theme?.customSettings?.themeColor}`,
                                        background: "none",
                                        textTransform: "inherit",
                                        padding: "6px 15px",
                                        // marginTop: "12px !important",
                                    }}
                                >
                                    Reset
                                </Button>
                            </Stack>

                        </Stack>
                        {addAccess &&
                            <Button
                                variant="contained"
                                // startIcon={<FaPlus sx={{ marginBottom: "2px" }} />}
                                startIcon={<AddNewIcon style={{ height: "20px", width: "20px", fill: "#FFFFFF" }}  />}
                                onClick={handleAddWorkFlow}
                                sx={{
                                    backgroundColor: `${theme?.customSettings?.themeColor}`,
                                    color: "#FFF",
                                    padding: "5px 20px",
                                    fontWeight: "500",
                                    textTransform: "none",
                                    fontSize: "16px",
                                    marginTop: "11px",
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    '&.Mui-disabled': {
                                        border: 'none'
                                    }
                                }}
                            >
                                Add Workflow
                            </Button>
                        }
                    </Box>
                </Grid2>
                <Grid2 size={12} sx={{ mt: 2 }}>
                    <TableComponent
                        columns={columns
                            .map((col) =>
                                col.field === "action"
                                    ? {
                                        ...col,
                                        option: {
                                            ...col.option,
                                            edit: editAccess,
                                        },
                                    }
                                    : col
                            )
                            .filter((col) => {
                                if (col.field !== "action") {
                                    return true;
                                } else {
                                    return Object.values(col.option).some((v) => v === true);
                                }

                            })}
                        data={workflowList?.data?.data}
                        isLoading={workflowList?.isLoading}
                        actionEdit={handleEditWorkFlow}
                    />
                    {!workflowList?.isLoading && (
                        <Box sx={{ display: "flex", justifyContent: "end" }}>
                            <PaginationComponent
                                pageNumber={workflowList?.data?.pageNumber || 1}
                                totalPages={Math.ceil(workflowList?.data?.totalRecords / workflowList?.data?.pageSize) || 1}
                                onPageChange={setPageNumber}
                            />
                        </Box>
                    )}
                </Grid2>
            </Grid2>
            {isWorkFlow &&
                <AddWorkFlow open={isWorkFlow} cancel={handleAddWorkFlow} openNotification={openNotification} />
            }
            {isEditWorkFLow &&
                <EditWorkFlow open={isEditWorkFLow} rowData={rowData} cancel={handleEditWorkFlow} openNotification={openNotification} />
            }
        </>
    );
};

export default AllWorkFlowList;
